import React from "react";

// seo
import Helmet from "react-helmet";
// import { helmetJsonLdProp } from "react-schemaorg";

import Section from "../../components/shared-ui/Section/Section";

// @todo - change to PED versions
import PEDLayout from "./PEDLayout";
import PEDHeroHeader from "../../components/HeroHeader/PEDHeroHeader";
import PEDStayConnectedForm from "../../components/PEDStayConnectedForm/PEDStayConnectedForm";

import "../../css/PED/StayConnected.scss";

export default function StayConnected() {
  return (
    <React.Fragment>
      <Helmet>
        <title>Caring for a Child with Chronic ITP | DOPTELET® and DOPTELET Sprinkle (avatrombopag)</title>
        <meta name="description" content="Get useful information to help care for your child with persistent or chronic ITP. Sign up for updates and helpful resources." />
      </Helmet>
      <PEDLayout pageClass="ped-resources-stay-connected">
        <PEDHeroHeader
          extraClass="large-hero inner-bg home-hero"
          markup={
            <>
              <h1>
                Sign Up to Learn More about Doptelet (AVATROMBOPAG), Doptelet Sprinkle (AVATROMBOPAG), and ITP
              </h1>
              <p>
                Sign up for tools and tips to help you manage your child’s
                persistent or chronic ITP.
              </p>
            </>
          }
          maxWidth="525"
          bgImage={[
            "/images/ped/hero/sign-up-hero-desktop.jpg",
            "/images/ped/hero/sign-up-hero-desktop.jpg",
          ]}
          bgImageMobile={[
            "/images/ped/hero/sign-up-hero.png",
            "/images/ped/hero/sign-up-hero@2x.png",
          ]}
        />

        <Section sectionClass="section-padding">
          <div className="coming-soon-cta">
            <h2>Coming soon: Doptelet Sprinkle</h2>
            <p>
              Doptelet Sprinkle has been approved for persistent or chronic
              pediatric ITP for kids 1 year and older to less than 6 years—Sobi
              is working to make it available as soon as possible. Sign up below
              to be notified as soon as it is available.
            </p>
          </div>
        </Section>

        <Section sectionClass="stay-connected-form-wrapper">
          <PEDStayConnectedForm />
          {/* <form className="ped-stay-connected-form">
            <div className="form-group">
              <p>*Indicates required field.</p>
            </div>
            <div className="form-group">
              <label>Your name*</label>
              <input type="text" />
            </div>
            <div className="form-group">
              <label>What best describes your situation?*</label>
              <input type="text" />
            </div>
            <div className="form-group">
              <label>Email address*</label>
              <input type="email" />
            </div>
            <div className="form-group">
              <label>
                Phone number <em>(Optional)</em>
              </label>
              <input type="text" />
            </div>
            <div className="form-group">
              <label>ZIP code*</label>
              <input type="text" />
            </div>
            <div className="form-group form-group-checkbox">
              <input type="checkbox" />
              <p>
                I’m at least 18 years old and I agree to the Sobi, Inc.{" "}
                <a
                  href="https://www.sobi.com/usa/en/terms-and-conditions/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms and Conditions
                </a>{" "}
                and{" "}
                <a
                  href="https://www.sobi.com/usa/en/privacy-policy-us/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
                .*
              </p>
            </div>
            <div className="">
              <p>
                Sobi, Inc. may use my information for market research or to
                evaluate and improve the company’s services and programs. I
                understand that I may stop Sobi, Inc. from contacting me at any
                time by clicking the “Unsubscribe” link in the emails I receive
                from Sobi, Inc. I understand that Sobi, Inc. will not sell or
                rent my personally identifiable information.
              </p>
            </div>
            <div className="form-group form-group-action">
              <div>
                <a href="/ped/" className="btn btn-primary">
                  <span>Sign me up</span>
                </a>
              </div>
            </div>
          </form> */}
        </Section>

        <Section sectionClass="section-padding">
          <div className="more-information">
            <div className="more-info-content">
              <h2>
                Looking for more information about persistent &amp; chronic ITP?
              </h2>
              <p>
                Learn about the different types of ITP in children and how they
                are treated.
              </p>
            </div>
            <div className="more-info-cta">
              <a
                href="/pediatric-itp/what-is-itp-in-children/"
                className="btn btn-primary btn-arrow w-100 about-persistent-button"
              >
                <span>About Persistent &amp; Chronic ITP</span>
              </a>
            </div>
          </div>
        </Section>
      </PEDLayout>
    </React.Fragment>
  );
}
